/* eslint-disable */
import "sortable-tablesort/sortable.min.js";

const initDatatables = () => {
  const datatables = document.querySelectorAll(".js-datatable-parent");

  datatables.forEach((datatable) => {
    const id = datatable.id;
    initDatatableFilter(id, datatable);
  });
};

const createId = (optionText) => {
  // Generate a unique option ID based on the option text
  return optionText
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-ščž]/g, "")
    .replace(/š/g, "s")
    .replace(/č/g, "c")
    .replace(/ž/g, "z")
    .replace(/-+/g, "-");
};

const getAllFilters = (id, parent) => {
  const globalFilters = [];

  // Select all elements with the class "js-datatable-filter"
  const filters = parent.querySelectorAll(".js-datatable-filter");

  // If no filters are found, exit the function
  if (!filters.length) return;

  // Iterate over each filter element
  filters.forEach((filter) => {
    // Select all header elements within the filter
    const allHeaders = filter.querySelectorAll("th");

    // Iterate over each header and its index
    allHeaders.forEach((header, index) => {
      // Check if the header is marked as filtrable
      const isFiltrable = header.getAttribute("data-filtrable") === "true";

      // If the header is filtrable
      if (isFiltrable) {
        // Extract and clean the filter name
        const filterName = header.textContent.trim();

        // Generate a unique filter ID based on the filter name
        let filterID = filterName
          .toLowerCase()
          .replace(/\s+/g, "-")
          .replace(/[^\w-ščž]/g, "")
          .replace(/š/g, "s")
          .replace(/č/g, "c")
          .replace(/ž/g, "z");

        // Remove consecutive dashes
        filterID = filterID.replace(/-+/g, "-");

        filterID = `${id}-${filterID}`;

        // Initialize a set to track unique options and an array to store them
        const optionsSet = new Set();
        const options = [];

        // Select all cells in the current column
        filter.querySelectorAll(`td:nth-child(${index + 1})`).forEach((td) => {
          // Extract and clean the option text
          // const optionText = td.textContent.split("\n")[0].trim();
          const optionText = td.textContent.trim().split('\n')[0];
          // Call the createId function and capture the result
          const optionID = createId(optionText);

          let optionIDwithIDprepend = `${id}-${optionID}`;

          // If the option ID is not already in the set, add it to the set and the options array
          if (!optionsSet.has(optionID)) {
            optionsSet.add(optionID);
            options.push({ text: optionText, id: optionIDwithIDprepend, idOnly: optionID });
          }
        });

        // Add the filter details to the globalFilters array
        globalFilters.push({ name: filterName, id: filterID, index, options });

        const rows = parent.querySelectorAll("table tr");

        rows.forEach((row) => {
          const cells = row.querySelectorAll("td");

          cells.forEach((cell, index) => {
            const filterInfo = globalFilters.find((filter) => filter.index === index);

            if (filterInfo) {
              const filterId = filterInfo.id;
              cell.setAttribute("data-filter-id", filterId);
            }
          });
        });
      }
    });
  });

  return globalFilters;
};

const initDatatableFilter = (id, parent) => {
  const filterForm = document.querySelector(".js-filter-form");
  const activeFilterCounter = {};
  const filterValues = {};

  ///////////////////////////////////////////////
  /////////////////// DESKTOP ///////////////////
  ///////////////////////////////////////////////
  const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

  // Function to seed desktop filters
  const seedDesktopFilters = () => {
    /*
      Handle logic for desktop filters
      1. Find columns that have data-filtrable="true"
      2. Build an array of filters and remove duplicate options -> generate ID's for filters
      3. Build DOM elements for each filter and its options (copy existing nodes and fill data-attributes / labels)
      4. Append filters to the DOM
    */

    // Get all filters based on the provided ID and parent element
    const globalFilters = getAllFilters(id, parent);

    // If not on a desktop, exit the function
    if (!isDesktop) return;

    // Select the filter wrapper outside the loop
    const filtersWrapper = parent.querySelector(".filters-datatable-wrapper-inner-desktop");
    const filterWrapper = filtersWrapper.querySelector(".datatable-filter-wrapper");

    // Iterate through each global filter
    globalFilters.forEach((filter) => {
      // Clone the filter wrapper for each filter
      const clonedFilterWrapper = filterWrapper.cloneNode(true);

      // Set attributes for the cloned filter wrapper
      clonedFilterWrapper.setAttribute("data-filter-id", `${filter.id}`);
      clonedFilterWrapper.setAttribute("data-in-mobile-modal", `${filter.id}`);

      // Get the button inside the cloned filter wrapper
      const filterButton = clonedFilterWrapper.querySelector("button");

      // Set attributes for the filter button
      filterButton.setAttribute("id", `${filter.id}-filter`);
      filterButton.setAttribute("data-filter-id", `${filter.id}-filter`);
      filterButton.setAttribute("data-panel", `${filter.id}-filter-panel`);

      // Get the text span inside the filter button and set its content
      const filterText = filterButton.querySelector("span.js-datatable-filter-toggle-text");
      filterText.textContent = filter.name;

      // Get the dropdown menu and list item inside the cloned filter wrapper
      const filterDropdown = clonedFilterWrapper.querySelector(".dropdown-menu");
      const filterUL = filterDropdown.querySelector("ul");
      const filterLI = filterUL.querySelector("li");

      filterUL.setAttribute("data-filter-id", `${filter.id}`);

      // Iterate through each option of the filter
      filter.options.forEach((option) => {
        // Clone the list item for each option
        const clonedFilterLI = filterLI.cloneNode(true);

        // Get the input and label inside the cloned list item
        const input = clonedFilterLI.querySelector("input");
        const label = clonedFilterLI.querySelector("label");

        // Set attributes for the input and label
        input.setAttribute("name", `${filter.id}-filter-optionid-${option.idOnly}`);
        input.setAttribute("value", `optionid-${option.idOnly}`);
        input.setAttribute("id", `${filter.id}-filter-optionid-${option.idOnly}`);
        input.removeAttribute("checked");
        input.setAttribute("data-show-all", "false");
        label.setAttribute("for", `${filter.id}-filter-optionid-${option.idOnly}`);
        label.textContent = option.text;

        // Append the cloned list item to the filter's list
        filterUL.appendChild(clonedFilterLI);
      });

      // Append the cloned filter wrapper to the filters wrapper
      filtersWrapper.appendChild(clonedFilterWrapper);

      // Get all filter wrappers in the filters wrapper
      const getAllFilters = filtersWrapper.querySelectorAll(".datatable-filter-wrapper");

      // Iterate through each filter wrapper and remove it if the button text is empty
      getAllFilters.forEach((filter) => {
        if (filter.querySelector("button span").textContent.trim() == "") {
          filter.remove();
        }
      });
    });
  };

  seedDesktopFilters();

  //////////////////////////////////////////////
  /////////////////// MOBILE ///////////////////
  //////////////////////////////////////////////
  const isMobile = window.matchMedia("(max-width: 1024px)").matches;

  // Function to seed mobile filters
  const seedMobileFilters = () => {
    // Get all filters based on the provided id and parent
    const globalFilters = getAllFilters(id, parent);

    // If not on a mobile, exit the function
    if (!isMobile) return;

    // Get DOM elements needed for mobile filters
    const filtersWrapper = parent.querySelector(".filters-datatable-wrapper-inner-mobile");
    const modalBody = filtersWrapper.querySelector(".modal-body");
    const filterWrapper = filtersWrapper.querySelector(".modal-filters-wrapper");
    const filterUL = filterWrapper.querySelector("ul");
    const filterLI = filterUL.querySelector("li");
    const filterPanel = filtersWrapper.querySelector(".datatable-modal-filter-panel");

    // Loop through global filters
    globalFilters.forEach((filter) => {
      // Clone filter list item for mobile
      const clonedFilterLI = filterLI.cloneNode(true);
      const button = clonedFilterLI.querySelector("button");
      const buttonText = button.querySelector("span");
      const buttonCounter = button.querySelector(".js-datatable-filter-counter");

      // Set attributes and text content based on filter properties
      button.setAttribute("data-filter-id", `${filter.id}-filter`);
      button.setAttribute("data-target", `${filter.id}-filter-panel`);
      buttonText.textContent = filter.name;

      // Append button counter and cloned filter list item
      buttonText.appendChild(buttonCounter);
      filterUL.appendChild(clonedFilterLI);

      // Remove empty filters from the list
      const getAllFilters = filtersWrapper.querySelectorAll(".modal-filters-wrapper ul li");
      getAllFilters.forEach((filter) => {
        if (filter.querySelector("button span").textContent.trim() == "") {
          filter.remove();
        }
      });
    });

    // Loop through global filters again for filter panels
    globalFilters.forEach((filter) => {
      // Clone filter panel for mobile
      const clonedFilterPanel = filterPanel.cloneNode(true);
      const panelTitle = clonedFilterPanel.querySelector(".datatable-modal-filter-panel-title span");
      const panelCounter = clonedFilterPanel.querySelector(".js-datatable-filter-counter");
      const panelContent = clonedFilterPanel.querySelector(".modal-datatable-panel-content");
      const panelUL = panelContent.querySelector("ul");
      const panelLI = panelUL.querySelector("li");

      // Set attributes and text content based on filter properties
      clonedFilterPanel.id = `${filter.id}-filter-panel`;
      panelTitle.textContent = filter.name;

      // Append panel counter and cloned filter panel to modal body
      panelTitle.appendChild(panelCounter);
      modalBody.appendChild(clonedFilterPanel);

      // Loop through filter options and clone list items
      filter.options.forEach((option) => {
        panelUL.setAttribute("data-filter-id", `${filter.id}`);

        const clonedPanelLI = panelLI.cloneNode(true);
        const input = clonedPanelLI.querySelector("input");
        const label = clonedPanelLI.querySelector("label");

        // Set attributes and text content based on option properties
        input.setAttribute("name", `${filter.id}-filter-optionid-${option.idOnly}`);
        input.setAttribute("value", `optionid-${option.idOnly}`);
        input.setAttribute("id", `${filter.id}-filter-optionid-${option.idOnly}`);
        input.removeAttribute("checked");
        input.setAttribute("data-show-all", "false");
        label.setAttribute("for", `${filter.id}-filter-optionid-${option.idOnly}`);
        label.textContent = option.text;

        // Append cloned list item to panel UL
        panelUL.appendChild(clonedPanelLI);
      });

      // Remove empty filter panels from the list
      const getAllFilterPanels = filtersWrapper.querySelectorAll(".datatable-modal-filter-panel");
      getAllFilterPanels.forEach((panel) => {
        if (panel.querySelector(".datatable-modal-filter-panel-title span").textContent.trim() == "") {
          panel.remove();
        }
      });
    });
  };

  seedMobileFilters();

  // Adds event listeners to mobile filters
  const addMobileEventListeners = () => {
    if (!isMobile) return;

    const filterButtons = parent.querySelectorAll(".js-modal-filter-btn");
    const backToFirstLevelBtn = parent.querySelector(".js-filter-modal-to-first-level");

    filterButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const targetId = btn.dataset.target;
        const target = parent.querySelector(`#${targetId}`);
        if (!target) return;

        target.classList.add("--active");
        backToFirstLevelBtn.querySelector("svg").classList.add("--active");
      });
    });

    // Open filter by default if there is only one
    if (filterButtons.length === 1) {
      filterButtons[0].click();
    }

    if (filterButtons.length > 1) {
      backToFirstLevelBtn.addEventListener("click", () => {
        const panels = document.querySelectorAll(".js-datatable-modal-filter-panel");
        panels.forEach((btn) => {
          btn.classList.remove("--active");
        });

        backToFirstLevelBtn.querySelector("svg").classList.remove("--active");
      });
    }

    // Clear button events for mobile filters
    const mobileClearBtn = document.querySelector(".modal-footer .js-datatable-filter-reset");
    mobileClearBtn.addEventListener("click", () => {
      const inputs = document.querySelectorAll(".js-datatable-filter-options input[type='checkbox']");
      inputs.forEach((input) => {
        // eslint-disable-next-line no-param-reassign
        if (input.id === "filter-all") {
          input.checked = true;
        } else {
          input.checked = false;
        }
      });

      countActiveFilters();
      updateCounters();

      // Close the 2nd level panel
      const panels = document.querySelectorAll(".js-datatable-modal-filter-panel");
      panels.forEach((btn) => {
        btn.classList.remove("--active");
      });
    });
  };

  addMobileEventListeners();

  // "Potrdi" button click
  if (isDesktop) {
    const submitBtns = parent.querySelectorAll("button.special-potrdi.desktop");
    const showMore = parent.querySelector(".show-more");

    submitBtns.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        getActiveFilters();

        const passActiveFilters = getActiveFilters();
        handleSubmit(passActiveFilters);

        if (passActiveFilters.length === 0) {
          const parent = findNearestParent(btn, "datatable-filter-wrapper");

          if (parent) {
            const getAllCheckboxes = parent.querySelectorAll("ul li input");

            getAllCheckboxes.forEach((checkbox) => {
              if (checkbox.id === "filter-all") {
                checkbox.checked = true;
              }
            });
          }

          showMore.classList.remove("d-none");
        } else {
              showMore.classList.add("d-none");
        }

        // Find the nearest parent with the class "datatable-filter-wrapper"
        const parent = findNearestParent(btn, "datatable-filter-wrapper");

        // If a valid parent is found, find the related elements and remove the "show" class
        if (parent) {
          const dropdownToggle = parent.querySelector(".dropdown-toggle");
          const dropdownMenu = parent.querySelector(".dropdown-menu");

          if (dropdownToggle) {
            dropdownToggle.classList.remove("show");
          }

          if (dropdownMenu) {
            dropdownMenu.classList.remove("show");
          }
        }
      });
    });
  } else {
    const submitBtn = parent.querySelector("button.button--filter-submit");
    const showMore = parent.querySelector(".show-more");

    submitBtn.addEventListener("click", function (e) {
      e.preventDefault();
      getActiveFilters();

      const passActiveFilters = getActiveFilters();
      handleSubmit(passActiveFilters);

      if (passActiveFilters.length === 0) {
        showMore.classList.remove("d-none");
      } else {
        showMore.classList.add("d-none");
      }

      const getAllPanels = parent.querySelectorAll(".datatable-modal-filter-panel");

      getAllPanels.forEach((panel) => {
        const getAllCheckboxes = panel.querySelectorAll(".modal-datatable-panel-content ul li input:not([data-show-all='true'])");

        let allUnchecked = true;

        getAllCheckboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            allUnchecked = false;
            return; // exit forEach loop early if any checkbox is checked
          }
        });

        if (allUnchecked) {
          const getShowAllCheckbox = panel.querySelector(".modal-datatable-panel-content ul li input[data-show-all='true']");

          if (getShowAllCheckbox && !getShowAllCheckbox.checked) {
            getShowAllCheckbox.checked = true;
            getShowAllCheckbox.dispatchEvent(new Event("change"));
          }
        }
      });
    });
  }

  function findNearestParent(element, className) {
    // Traverse up the DOM until a parent with the specified class is found
    while (element && !element.classList.contains(className)) {
      element = element.parentElement;
    }
    return element;
  }

  const getActiveFilters = () => {
    const getAllFilters = parent.querySelectorAll(".js-datatable-filter-options");
    const removeDuplicateValues = new Set();

    getAllFilters.forEach((filter) => {
      const getAllFilterOptions = filter.querySelectorAll("input");
      const filterId = filter.getAttribute("data-filter-id");

      getAllFilterOptions.forEach((option) => {
        if (option.checked && option.getAttribute("data-show-all") !== "true") {
          const optionValue = option.getAttribute("value");

          const filterString = JSON.stringify({
            filterId: filterId,
            optionValue: optionValue,
          });

          removeDuplicateValues.add(filterString);
        }
      });
    });

    return Array.from(removeDuplicateValues).map((filterString) => JSON.parse(filterString));
  };

  const countActiveFilters = () => {
    const filterOptions = parent.querySelectorAll(".js-datatable-filter-options");

    filterOptions.forEach((filter) => {
      const { filterId } = filter.dataset;
      // Count only checkboxes, radio buttons are excluded
      const active = filter.querySelectorAll("input[type='checkbox']:not([data-show-all='true']):checked");
      activeFilterCounter[`filter-${filterId}`] = active.length;
    });
  };

  const updateCounters = () => {
    const filterWrappers = parent.querySelectorAll(".js-datatable-filter");
    const totalActiveFilters = Object.values(activeFilterCounter).reduce((a, b) => a + b, 0);

    // Desktop
    filterWrappers.forEach((filter) => {
      const { filterId } = filter.dataset;
      const clearBtns = filter?.querySelectorAll(".js-datatable-filter-reset");
      const toggleButton = filter.querySelector(".js-datatable-filter-toggle");
      const counters = filter.querySelectorAll(".js-datatable-filter-counter");

      if (filterId && counters) {
        counters.forEach((counter) => {
          if (activeFilterCounter[`filter-${filterId}`] > 0) {
            // eslint-disable-next-line no-param-reassign
            counter.innerHTML = `(${activeFilterCounter[`filter-${filterId}`]})`;
            toggleButton.classList.add("--has-active-filters");
          } else {
            // eslint-disable-next-line no-param-reassign
            counter.innerHTML = "";
            toggleButton.classList.remove("--has-active-filters");
          }
        });

        clearBtns.forEach((btn) => {
          if (activeFilterCounter[`filter-${filterId}`] > 0) {
            btn.classList.remove("--is-invisible");
          } else {
            btn.classList.add("--is-invisible");
          }
        });
      }
    });

    // Mobile
    const mobileFilterBtns = parent.querySelectorAll(".js-modal-filter-btn");

    mobileFilterBtns.forEach((filter) => {
      const { filterId } = filter.dataset;
      const cleanedFilterId = filterId.slice(0, -7); // Remove the last 7 characters ("-filter")
      const counters = filter?.querySelectorAll(".js-datatable-filter-counter");

      counters.forEach((counter) => {
        if (activeFilterCounter[`filter-${cleanedFilterId}`] > 0) {
          // eslint-disable-next-line no-param-reassign
          counter.innerHTML = " " + `(${activeFilterCounter[`filter-${cleanedFilterId}`]})`;
        } else {
          // eslint-disable-next-line no-param-reassign
          counter.innerHTML = "";
        }
      });
    });

    // Mobile global clear button
    const mobileClearBtn = document.querySelector(".modal-footer .js-datatable-filter-reset");
    const mobileClearBtnCounter = mobileClearBtn.querySelector(".js-datatable-filter-counter");
    if (mobileClearBtn && totalActiveFilters > 0) {
      mobileClearBtnCounter.innerHTML = `(${totalActiveFilters})`;
      mobileClearBtn.classList.remove("--is-invisible");
    } else {
      mobileClearBtnCounter.innerHTML = ``;
      mobileClearBtn.classList.add("--is-invisible");
    }

    const mobileOpenFilterBtn = document.querySelector(".js-mobile-filter-btn");
    const mobileOpenFilterBtnCounter = mobileOpenFilterBtn.querySelector(".js-datatable-filter-counter");

    mobileOpenFilterBtnCounter.innerHTML = `(${totalActiveFilters})`;

    if (mobileOpenFilterBtnCounter && totalActiveFilters > 0) {
      mobileOpenFilterBtnCounter.innerHTML = `(${totalActiveFilters})`;
      mobileOpenFilterBtn.classList.add("--has-active-filters");
    } else {
      mobileOpenFilterBtnCounter.innerHTML = ``;
      mobileOpenFilterBtn.classList.remove("--has-active-filters");
    }
  };

  const addDesktopEventListeners = () => {
    const filterOptions = document.querySelectorAll(".js-datatable-filter-options");

    // Track active checkboxes
    filterOptions.forEach((filterOption) => {
      let inputs = filterOption.querySelectorAll("input[type='checkbox']");

      inputs.forEach((input) => {
        input.addEventListener("change", () => {
          // If "Show all" option is selected, deselect all other filters
          const { showAll } = input.dataset;
          if (showAll === true || showAll === "true") {
            const allInputs = filterOption.querySelectorAll("input[type='checkbox']");
            allInputs.forEach((checkbox) => {
              if (checkbox !== input) {
                // eslint-disable-next-line no-param-reassign
                checkbox.checked = false;
              }
            });
          }

          if (showAll === false || showAll === "false" || !showAll) {
            const showAllInput = filterOption.querySelector("input[type='checkbox'][data-show-all='true']");
            if (showAllInput) {
              showAllInput.checked = false;
            }
          }

          countActiveFilters();
          updateCounters();
        });
      });
    });

    // Clear button events for desktop filters
    const filterWrappers = parent.querySelectorAll(".js-datatable-filter");
    filterWrappers.forEach((filter) => {
      const clearBtn = filter.querySelector(".js-datatable-filter-reset");
      let inputs = filter.querySelectorAll("input[type='checkbox']");

      if (!isMobile) {
        if (clearBtn) {
          clearBtn.addEventListener("click", () => {
            inputs.forEach((input) => {
              // Use getAttribute('id') instead of getAttribute.id
              if (input.getAttribute("id") === "filter-all") {
                input.checked = true;
              } else {
                input.checked = false;
              }
            });

            countActiveFilters();
            updateCounters();

            /* filterForm.submit(); */
            /* handleSubmit(); */
          });
        }
      }
    });

    /*
    // Sorting
    const sortingOptions = document.querySelectorAll(".js-sorting-option");
    if (sortingOptions && sortingOptions.length > 0) {
      sortingOptions.forEach((option) => {
        option.addEventListener("change", (e) => {
          handleSorting(e);
        });
      });
    }
    */
  };

  addDesktopEventListeners();

  const handleSubmit = (passActiveFilters) => {
    const transformedObject = {};

    passActiveFilters.forEach((item) => {
      const { filterId, optionValue } = item;

      if (!transformedObject[filterId]) {
        transformedObject[filterId] = [optionValue];
      } else {
        transformedObject[filterId].push(optionValue);
      }
    });

    const rows = parent.querySelectorAll("table tbody tr");

    if (Object.keys(transformedObject).length === 0) {
      // If transformedObject is empty, show all rows
      rows.forEach((row) => {
        row.classList.remove("d-none");
      });
    } else {
      rows.forEach((row) => {
        let isVisible = false;

        for (let key of Object.keys(transformedObject)) {
          const cells = row.querySelectorAll(`td[data-filter-id="${key}"]`);

          cells.forEach((cell) => {
            const id = createId(cell.textContent.trim().split("\n")[0]);

            // Assuming transformedObject[key] is an array
            const transformedValues = transformedObject[key].map((value) => value.replace("optionid-", ""));

            if (transformedValues.includes(id)) {
              isVisible = true;
            }
          });
        }

        if (!isVisible) {
          row.classList.add("d-none");
        } else {
          row.classList.remove("d-none");
        }
      });
    }
  };

  const handleSorting = (e) => {
    const getAllSortable = parent.querySelectorAll("table thead tr th:not(.no-sort)");
    const razvrstiButton = parent.querySelector(".sorting-list-wrapper button.razvrsti");
    const razvrstiDropdown = parent.querySelector(".sorting-list-wrapper .dropdown-menu");
    const razvrstiUL = razvrstiDropdown.querySelector("ul");
    const razvrstiLI = razvrstiDropdown.querySelector("li");

    getAllSortable.forEach((sortable) => {
      const clonedRazvrstiLI = razvrstiLI.cloneNode(true);
      const razvrstiButton = clonedRazvrstiLI.querySelector("button");
      razvrstiButton.textContent = sortable.textContent;

      const createValue = createId(sortable.textContent);
      razvrstiButton.setAttribute("value", createValue);

      razvrstiUL.appendChild(clonedRazvrstiLI);
    });

    const getAllButtons = razvrstiUL.querySelectorAll("li button");
    const allSortableArray = Array.from(getAllSortable);

    getAllButtons.forEach((button) => {
      if (button.textContent.trim() === "" || button.textContent.trim() === "Null") {
        const getParent = button.closest("li");
        getParent.remove();
      }

      button.addEventListener("click", () => {
        getAllButtons.forEach((otherButton) => {
          otherButton.classList.remove("active");
        });

        button.classList.add("active");
      });
    });

    const getAllLI = razvrstiUL.querySelectorAll("li");
    getAllLI.forEach((li) => {
      li.addEventListener("click", (e) => {
        e.preventDefault();
        const thWithSameText = allSortableArray.find((th) => th.textContent.trim() === li.textContent.trim());

        if (thWithSameText) {
          thWithSameText.click();
        }
      });
    });
  };

  handleSorting();

  const initShowMore = () => {
    const getAllTableRows = parent.querySelectorAll("table tbody tr");
    const totalRows = getAllTableRows.length;
    const showMore = parent.querySelector(".show-more");
    let shownRows = 0;

    // DEV ENV ONLY - THIS NEEDS TO BE COMMENTED BECAUSE d-none CLASS WILL BE SET BY BACKEND
    getAllTableRows.forEach((row, index) => {
      if (index < 4) {
        row.classList.remove("d-none");
        shownRows++;
      } else {
        if (!showMore.classList.contains("d-none")){
          row.classList.add("d-none");
        }
      }
    });

    const textWrapper = showMore.querySelector(".text-wrapper");
    const currentCount = textWrapper.querySelector(".current-count");
    const totalCount = textWrapper.querySelector(".total-count");
  
    // const lastSpan = textWrapper.querySelector("span:last-child");
    const progressBar = showMore.querySelector(".js-fill-progress-bar");
    const button = showMore.querySelector("button");

    currentCount.textContent = shownRows;
    totalCount.textContent = totalRows;
    // lastSpan.textContent = "salonov oz. dvoran";

    // Calculate the initial progress percentage
    const initialProgressPercentage = (shownRows / totalRows) * 100;

    // Set the initial progress bar width
    // eslint-disable-next-line
    progressBar.style.width = initialProgressPercentage + "%";

    // Function to update progress bar based on new data
    function updateProgressBar(newCurrentCount) {
      const progressPercentage = (newCurrentCount / totalRows) * 100;

      // eslint-disable-next-line
      progressBar.style.width = progressPercentage + "%";
      currentCount.textContent = newCurrentCount;

      if (newCurrentCount == totalRows) {
        button.classList.add("d-none");
      } else {
        button.classList.remove("d-none");
      }
    }

    button.addEventListener("click", () => {
      getAllTableRows.forEach((row) => {
        row.classList.remove("d-none");
        const getAllTableRows = parent.querySelectorAll("table tbody tr");

        updateProgressBar(getAllTableRows.length);
      });
    });

    if (isDesktop) {
      const desktopSubmitButton = parent.querySelectorAll("button.special-potrdi.desktop");

      desktopSubmitButton.forEach((btn) => {
        btn.addEventListener("click", function (e) {
          e.preventDefault();

          const getAllTableRows = parent.querySelectorAll("table tbody tr");
          updateProgressBar(getAllTableRows.length);
        });
      });
    }

    if (isMobile) {
      const mobileSubmitButton = parent.querySelector("button.button--filter-submit");

      mobileSubmitButton.addEventListener("click", function (e) {
        e.preventDefault();

        const getAllTableRows = parent.querySelectorAll("table tbody tr");
        updateProgressBar(getAllTableRows.length);
      });
    }
  };

  initShowMore();
};

export default initDatatables;
